import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { AlertService } from '../shared/services/alert.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserRoles, CurrentUserService } from '../shared/services/current-user.service';

@Injectable()
export class UserRoleGuard implements CanActivate {

    constructor(
        private currentUserService: CurrentUserService,
        private alertService: AlertService) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const allowedRoles = route.data.allowedRoles as UserRoles;
        const message = route.data.message as string;

        return this.currentUserService.get()
            .pipe(
                map(user => {
                    if (user.roles & allowedRoles) {
                        return true;
                    } else {
                        this.alertService.error(message);
                        return false;
                    }
                })
            );
    }
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/user-role-guard.ts